import React, {useEffect} from 'react'
import {PageWrap} from "../../Components";
import {Descriptions} from "antd";
import {useLocation} from "react-router-dom";

import styled from "styled-components";

const { Item } = Descriptions

const DescriptionsWrap = styled(Descriptions)`
  .ant-descriptions-item-label{
    width: 15% !important;
  }
  .ant-descriptions-item-content{
    width: 75% !important;
  }
`

const MyInfoPage = () => {
    const location = useLocation()

    useEffect(()=>{

    },[location])

    return (
        <PageWrap>
            <h3>내정보관리</h3>
            <DescriptionsWrap column={1} bordered>
                <Item label={"푸시알림 수신"}>
                    시스템 개선중으로 알림앱 사용이 불가합니다. 다온푸드 앱으로 통합 예정이며 사용 가능 시점에 공지 드리겠습니다.
                </Item>
            </DescriptionsWrap>
        </PageWrap>
    )
}

export default MyInfoPage
